import React from 'react';
import {SelectAsyncBase} from 'components/Forms/FormBases';
import {getPublicCECBs} from 'api/common';

SelectPublicCECB.defaultProps = {
  placeholder: 'Select a Certification Body',
  isClearable: false,
  cacheOptions: true,
  defaultOptions: true,
  onChange: () => {},
  getOptionLabel: (option) => option.certification_bodies_name,
  getOptionValue: (option) => option.certification_bodies_id,
};

function SelectPublicCECB(props) {
  const {ceId, value, ...rest} = props;

  async function getOptions(inputValue) {
    const query = {
      limit: 100,
      status: 'active',
      filter: {
        search: inputValue,
      },
    };

    try {
      const {data} = await getPublicCECBs(ceId, query);
      return data;
    } catch (error) {
      return [];
    }
  }

  return <SelectAsyncBase loadOptions={getOptions} {...rest} />;
}

export default SelectPublicCECB;
